import React from "react";
import AntdButton from "antd/lib/button";
// import { withError, useTracker, TrackEventType, getTrackEventInfo} from '@fishx/tracker';
import { withError } from '@fishx/tracker';


export const Button = (props) => {
    const { onClick, onKeyDown, onDoubleClick, ...other } = props;
    // const log = useTracker(Button.displayName);
    // let clickTimeId;
    return (
      <AntdButton
        {...other}
        // onClick={(e) => {
        //   onClick && onClick(e);
        //   clearTimeout(clickTimeId);
        //   const event = e.nativeEvent;
        //   clickTimeId = setTimeout(function() {
        //     log(getTrackEventInfo(event, TrackEventType.CLICK));
        //   }, 300);
          
        // }}
        // onKeyDown={(e) => {
        //   onKeyDown && onKeyDown(e);
        //   log(getTrackEventInfo(e, TrackEventType.KEYDOWN));
        // }}
        // onDoubleClick={(e) => {
        //   onDoubleClick && onDoubleClick(e);
        //   clearTimeout(clickTimeId);
        //   log(getTrackEventInfo(e, TrackEventType.DBCLICK));
        // }}
      ></AntdButton>
    );
  };

  Button.displayName = 'Button';

  export default withError(Button);



// WEBPACK FOOTER //
// ./src/components/button/index.tsx